import { createContext, useContext } from 'react'

export const createContextFactory = <T,>(
  methodName: string,
  providerName: string,
  defaultValue?: T
) => {
  const cxt = createContext<T | undefined>(defaultValue || undefined)

  const useContextFactory = () => {
    const usedCtx = useContext(cxt)
    if (usedCtx === undefined) {
      throw new Error(`${methodName} must be used within a ${providerName}.`)
    }
    return usedCtx
  }

  return [useContextFactory, cxt.Provider] as const
}
